import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import AccessSecurity from './AccessSecurity'
import ChangePassword from './ChangePassword'
import yn from 'yn'

const LoggedSidebar = props => {
  const { selected } = props

  return (
    <div
      className='userSidebar col-12 col-md-4 d-none d-lg-block pr-3 mb-2'
    >
      <div className='row mx-0'>
        <div className='col-12 px-0 bg-brand-5 radius border border-color-ui-3'>
          <div className='row px-0 mx-0'>
            <div className='col-12 px-0'>
              <ul role='menu'>
                <li
                  className={`user-item item-wishlist px-1 py-0 py-1 border-bottom border-color-ui-3 ${
                    selected === '/wishlist' ? 'active' : ''
                  }`}
                  role='menuitem'
                >
                  <div className='row align-items-center h-100 mx-0'>
                    <Link
                      className='wishlist-button txt-menu-listy col mr-auto btn btn-flat btn-sm btn-icon txt-left txt-font-body txt-uppercase'
                      to='/wishlist'
                      tabIndex='-1'
                    >
                      <i className='icon icon_wishlist' />
                      Favoritos
                    </Link>
                  </div>
                </li>
                {
                  (yn(process.env.REACT_APP_HAS_EXTRACT, { default: true })) && (
                    <li
                      className={`user-item item-extract px-1 py-0 py-1 border-bottom border-color-ui-3 ${
                        selected === '/extract' ? 'active' : ''
                      }`}
                      role='menuitem'
                    >
                      <div className='row align-items-center h-100 mx-0'>
                        <Link
                          className='extract-button txt-menu-listy col mr-auto btn btn-flat btn-sm btn-icon txt-left txt-font-body txt-uppercase'
                          to='/extract'
                          tabIndex='-1'
                        >
                          <i className='icon icon_listing' />
                      Extrato
                        </Link>
                      </div>
                    </li>
                  )}
                {
                  (yn(process.env.REACT_APP_HAS_ORDERS, { default: true })) && (
                    <li
                      className={`user-item item-order px-1 py-0 py-1 border-bottom border-color-ui-3 ${
                        selected === '/my-orders' ? 'active' : ''
                      }`}
                      role='menuitem'
                    >
                      <div className='row align-items-center h-100 mx-0'>
                        <Link
                          className='order-button txt-menu-listy col mr-auto btn btn-flat btn-sm btn-icon txt-left txt-font-body txt-uppercase'
                          to='/my-orders'
                          tabIndex='-1'
                        >
                          <i className='icon icon_package' />
                      Pedidos
                        </Link>
                      </div>
                    </li>
                  )}
                {
                  (yn(process.env.REACT_APP_HAS_TRAVEL, { default: true })) && (
                    yn(
                      process.env.REACT_APP_CATALOG_ID === '40455' ||
                  process.env.REACT_APP_CATALOG_ID === '40496' ||
                  process.env.REACT_APP_CATALOG_ID === '40543'
                    ) && (
                      <li
                        className={`user-item item-order px-1 py-0 py-1 border-bottom border-color-ui-3`}
                        role='menuitem'
                      >
                        <div className='row align-items-center h-100 mx-0'>
                          <a
                            className='order-button txt-menu-listy col mr-auto btn btn-flat btn-sm btn-icon txt-left txt-font-body txt-uppercase'
                            href='https://viagens.webpremios.digital/meus-pedidos' target='_self'
                            tabIndex='-1'
                          >
                            <i className='icon icon_airplane' />
                        Minhas viagens
                          </a>
                        </div>
                      </li>
                    )
                  )}
                {
                  (yn(process.env.REACT_APP_HAS_SCHEDULING, { default: true })) && (
                    <li
                      className={`user-item item-calendar px-1 py-0 py-1 border-bottom border-color-ui-3 ${
                        selected === '/scheduling' ? 'active' : ''
                      }`}
                      role='menuitem'
                    >
                      <div className='row align-items-center h-100 mx-0'>
                        <Link
                          className='calendar-button txt-menu-listy col mr-auto btn btn-flat btn-sm btn-icon txt-left txt-font-body txt-uppercase'
                          to='/scheduling'
                          tabIndex='-1'
                        >
                          <i className='icon icon_calendar' />
                          Resgates recorrentes
                        </Link>
                      </div>
                    </li>
                  )
                }
                {
                  (yn(process.env.REACT_APP_HAS_PROFILE, { default: true })) && (
                    <li
                      className={`user-item item-profile px-1 py-0 py-1 border-bottom border-color-ui-3 ${
                        selected === '/profile' ? 'active' : ''
                      }`}
                      role='menuitem'
                    >
                      <div className='row align-items-center h-100 mx-0'>
                        <Link
                          className='profile-button txt-menu-listy col mr-auto btn btn-flat btn-sm btn-icon txt-left txt-font-body txt-uppercase'
                          to='/profile'
                          tabIndex='-1'
                        >
                          <i className='icon icon_edit' />
                      Informações pessoais
                        </Link>
                      </div>
                    </li>
                  )}
                {
                  (yn(process.env.REACT_APP_HAS_ADDRESS, { default: true })) && (
                    <li
                      className={`user-item item-address px-1 py-0 py-1 border-bottom border-color-ui-3 ${
                        selected === '/my-address' ? 'active' : ''
                      }`}
                      role='menuitem'
                    >
                      <div className='row align-items-center h-100 mx-0'>
                        <Link
                          className='profile-button txt-menu-listy col mr-auto btn btn-flat btn-sm btn-icon txt-left txt-font-body txt-uppercase'
                          to='/my-address'
                          tabIndex='-1'
                        >
                          <i className='icon icon_truck' />
                      Endereço
                        </Link>
                      </div>
                    </li>
                  )}
                {
                  (yn(process.env.REACT_APP_HAS_SECURITY, { default: true })) && (
                    (yn(process.env.REACT_APP_ALLOW_SECURITY_ACCESS)) ? (
                      <AccessSecurity selected={selected} />
                    ) : (
                      <ChangePassword selected={selected} />
                    )
                  )
                }
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

LoggedSidebar.propTypes = {
  selected: PropTypes.any
}

export default LoggedSidebar



// WEBPACK FOOTER //
// ./src/App/Shell/LoggedSidebar.js